/**
 * @flow
 * @relayHash 7faff13a3597f8c938caa013f402c341
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type POStatus = "APPROVED" | "CANCELLED" | "PARTIALLY_RECEIVED" | "PENDING_APPROVAL" | "RECEIVED" | "REJECTED" | "SENT";
export type PurchaseOrderListQueryVariables = {|
  status?: ?POStatus
|};
export type PurchaseOrderListQueryResponse = {|
  +purchaseOrders: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +poNumber: string,
        +vendor: ?{|
          +id: string,
          +vendorNumber: string,
          +name: string,
        |},
        +status: POStatus,
        +totalAmount: number,
        +expectedDeliveryDate: ?any,
        +createdAt: any,
        +updatedAt: any,
      |}
    |}>
  |}
|};
export type PurchaseOrderListQuery = {|
  variables: PurchaseOrderListQueryVariables,
  response: PurchaseOrderListQueryResponse,
|};
*/


/*
query PurchaseOrderListQuery(
  $status: POStatus
) {
  purchaseOrders(status: $status) {
    edges {
      node {
        id
        poNumber
        vendor {
          id
          vendorNumber
          name
        }
        status
        totalAmount
        expectedDeliveryDate
        createdAt
        updatedAt
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "POStatus",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "edges",
    "storageKey": null,
    "args": null,
    "concreteType": "PurchaseOrderEdge",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": null,
        "concreteType": "PurchaseOrder",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "poNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "vendor",
            "storageKey": null,
            "args": null,
            "concreteType": "Vendor",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vendorNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "expectedDeliveryDate",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "updatedAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cursor",
        "args": null,
        "storageKey": null
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pageInfo",
    "storageKey": null,
    "args": null,
    "concreteType": "PageInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "endCursor",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNextPage",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PurchaseOrderListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "purchaseOrders",
        "name": "__PurchaseOrderList_purchaseOrders_connection",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PurchaseOrderConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PurchaseOrderListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "purchaseOrders",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PurchaseOrderConnection",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "purchaseOrders",
        "args": (v1/*: any*/),
        "handle": "connection",
        "key": "PurchaseOrderList_purchaseOrders",
        "filters": [
          "status"
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PurchaseOrderListQuery",
    "id": null,
    "text": "query PurchaseOrderListQuery(\n  $status: POStatus\n) {\n  purchaseOrders(status: $status) {\n    edges {\n      node {\n        id\n        poNumber\n        vendor {\n          id\n          vendorNumber\n          name\n        }\n        status\n        totalAmount\n        expectedDeliveryDate\n        createdAt\n        updatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "purchaseOrders"
          ]
        }
      ]
    }
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d11f36c23f500620b7dabd26ee98a02';
module.exports = node;
